module.exports = __webpack_public_path__ + "static/media/aggregate.52f376af.svg";